import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";

@Component({
  selector: "app-myprofile",
  templateUrl: "./myprofile.component.html",
  styleUrls: ["./myprofile.component.css"],
})
export class MyprofileComponent implements OnInit {
  apiUrl: string;
  updateProfileForm: FormGroup;
  submitted = false;
  dtOptions: any = {};
  roles: any[] = [];
  profile_image: string = "https://via.placeholder.com/100";
  profile_name: string = "";

  tempImage: File = null;
  imagePreviewSrc: string = null;

  file: any;
  filePath: any;
  covidtest_info: any;
  fileUrl: any;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService,
    private utility: UtilityService
  ) {}

  ngOnInit() {
    this.initialiseForm();
    this.initTable();
    this.getRoles();

    this.profile_image =
      localStorage.getItem("profile_image") == "null"
        ? this.profile_image
        : localStorage.getItem("profile_image");
    this.profile_name = localStorage.getItem("name");
  }

  initTable() {
    this.dtOptions = {
      paging: true,
      scrollX: true,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: true,
      processing: true,
      ordering: false,
      info: true,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  initialiseForm() {
    this.updateProfileForm = this.formBuilder.group({
      name: [
        localStorage.getItem("name"),
        [
        Validators.required, 
        Validators.maxLength(45),
        Validators.pattern("^[A-Za-z ]*$"),
      this.utility.noWhiteSpaceValidator],
      ],
      emailAddress: [
        localStorage.getItem("email"),
        [
          Validators.required,
          Validators.maxLength(45),
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ],
      ],
      roleName: [localStorage.getItem("role_id")],
      phoneNumber: [localStorage.getItem("phone"), [Validators.required]],
      profileImage: [""],
    });
  }

  onSubmit(formData) {
    this.submitted = true;

    if (this.updateProfileForm.invalid) {
      return;
    }

    this.spinnerService.show();

    // if (this.tempImage) {
    //   this.uploadImage(formData);
    //   return;
    // }

    this.submitForm(formData);
  }

  submitForm(formData) {
    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    var requestObj = {
      role_id: localStorage.getItem("role_id"),
      email: formData.emailAddress,
      name: formData.name,
      phone: formData.phoneNumber,
      status: localStorage.getItem("active"),
      id: localStorage.getItem("id"),
      profile_image: this.fileUrl,
    };

    this.apiUrl = environment.AUTHAPIURL + "users/update";

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        console.log(data);
        this.spinnerService.hide();

        if (data.status == true) {
          //update localStorage here
          localStorage.setItem("email", data.response.email);
          localStorage.setItem("phone", data.response.phone);
          localStorage.setItem("name", data.response.name);
          localStorage.setItem("profile_image", data.response.profile_image);

          if (this.tempImage) {
            this.profile_image = data.response.profile_image;
          }

          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Profile updated successfully",
            showConfirmButton: true,
            timer: 5000,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
  }

  // uploadImage(form) {
  //   // const myheaders = new HttpHeaders({
  //   //   token: localStorage.getItem('access_token')
  //   // });

  //   // const options = { headers: myheaders };

  //   const reqHeader = new HttpHeaders({
  //     "Content-Type": "multipart/form-data",
  //     "Accept": "application/json",
  //     Authorization: "Bearer " + localStorage.getItem("access_token"),
  //   });

  //   const formData = new FormData();
  //   formData.append("file", this.tempImage);

  //   this.apiUrl = environment.AUTHAPIURL + "file/upload";

  //   this.http
  //     .post<any>(this.apiUrl, formData, { headers: reqHeader })
  //     .subscribe((data) => {
  //       this.spinnerService.hide();

  //       if (data.response != null && data.status) {
  //         this.updateProfileForm.controls["profileImage"].setValue(
  //           data.response.url
  //         );
  //         this.submitForm(form);
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: data.message,
  //           showConfirmButton: true,
  //           timer: 5000,
  //           timerProgressBar: true,
  //         });
  //       }
  //     });
  // }

  getRoles() {
    this.spinnerService.show();
    this.apiUrl = environment.AUTHAPIURL + "roles";
    this.http.get<any>(this.apiUrl).subscribe((data) => {
      this.spinnerService.hide();
      if (data.status == true) {
        this.roles = data.response;
      } else {
        Swal.fire({
          icon: "info",
          title: "Oops...",
          text: data.message,
          showConfirmButton: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    });
  }

  handleImageUpload(profileImageInput: any) {
    this.tempImage = profileImageInput.files[0];
    this.previewImage();
  }

  previewImage() {
    if (/\.(jpe?g|png|gif)$/i.test(this.tempImage.name)) {
      let reader = new FileReader();

      reader.addEventListener(
        "load",
        function () {
          this.imagePreviewSrc = reader.result;
        }.bind(this),
        false
      );

      reader.readAsDataURL(this.tempImage);
    }
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.file = event.target.files[0];
      this.filePath = event.target.files[0].name;
      this.updateProfileForm.get("profileImage").setValue(file);

      this.apiUrl = environment.AUTHAPIURL + "file/upload";
      const reqHeader = new HttpHeaders({
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      });
      const formData = new FormData();
      formData.append("file", this.file);

      // this.fileUrl =
      // 	'http://localhost/eg-ctms-backend/public/uploadReport/sample-COVID-test-report_1624438663.jpg';
      this.http.post<any>(this.apiUrl, formData).subscribe((data) => {
        console.log("uploadApiResponse: ", data);
        this.spinnerService.hide();

        if (data.status == true) {
          this.fileUrl = data.response.url;
          this.profile_image = this.fileUrl;

          console.log(this.fileUrl);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
    }
  }
}
